// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding } from '@alto/design-system';
import React from 'react';

type Props = {
  readonly medicationName: string;
  readonly courierAgeRestrictionEnabled: boolean;
};

export const PhotoIDRequiredActionSheet = ({ medicationName, courierAgeRestrictionEnabled }: Props) => {
  if (courierAgeRestrictionEnabled) {
    return (
      <ActionSheetV2
        title="18+ photo ID & signature required"
        analyticsName="checkout photo id required"
      >
        <LgPadding topPadding={SPACING.STATIC.NONE}>
          <Body>
            {medicationName} is a controlled substance. Someone 18+ must be present to show a photo id and sign for this
            order.
          </Body>
        </LgPadding>
      </ActionSheetV2>
    );
  }

  return (
    <ActionSheetV2
      title="Signature required upon delivery"
      analyticsName="checkout signature required"
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>{medicationName} is a controlled substance and requires a signature upon delivery.</Body>
      </LgPadding>
    </ActionSheetV2>
  );
};
